export interface BandwidthSetting {
	bandwidthThreshold: number,
	bandwidthThresholdUnit: "MB" | "GB",
	tz: string;
	tenant?: string;
};